<div id="browsingHeader">
    <div class="container">
        <div class="row">
            <div id="summary" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <app-breadcrumbs></app-breadcrumbs>
                <div class="header">
                    <img
                        src="{{ node.posterImage }}"
                        alt="{{ node.posterImageAltText }}"
                        *ngIf="node.parents.length"
                    />
                    <h1 class="title selenium-subject-title" [ngStyle]="{ color: backgroundColor }">
                        {{ node.title }}
                    </h1>
                </div>
                <div class="description selenium-subject-description">
                    {{ node.description }}
                </div>
            </div>
        </div>
    </div>
</div>
